import { PendantList, PendantObj } from '@/base/module_config'
import Vue from 'vue'

const defaultGridConfig = {
  isOpen: false,
  color: '#EAEAEA',
  cellSize: 36
}
const localGridConfig = localStorage.getItem('gridConfig')
const gridConfig = localGridConfig ? JSON.parse(localGridConfig) : defaultGridConfig
const rulerIsOpen = localStorage.getItem('rulerIsOpen') === 'true'

// 整个系统的变量
const app = {
  namespaced: true,
  state: {
    showNavbar: true, // 正常为true,院校版为false
    tid: 10000,
    PendantList,
    PendantObj,
    theme_id: '', // 全局模板id,
    now_page: 'index', // 当前选中的页面
    module_Data: null, // 保存正在编辑的对象,
    module_animation_index: null, //  正在编辑第几个动画
    select_animation_visible: false,
    crop_img_dialog_visible: false,
    crop_img_dialog_type: 'img',
    page_template_panel_visible: false,
    edit_page_index: 0, // 在第index页点击了删除或者添加按钮
    is_replace_img: false,
    is_replace_vo: false,
    replace_img_type: 'img', // 替换图片：img图片挂件，page页面背景图,wipe 擦一擦
    // 当前选中的挂件集合
    select_module: [],
    multiple_selection_move: false,
    move_position: {
      id: '',
      top: 0,
      left: 0
    },
    gridConfig,
    rulerIsOpen,
    theme_info: {
      coverUrl: '',
      title: '未命名作品',
      worksDesc: '我用随传做了一个超酷炫的H5，快来看看吧',
      displayReadCount: 'N',
      readCount: 0
    },
    template_upload: {
      coverUrl: '',
      title: '未命名作品',
      templateDesc: '我用随传做了一个超酷炫的H5，快来看看吧',
      industry: [],
      purpose: [], // 用途
      holidays: '',
      function: [], // 功能
      style: '', // 风格
      color: '', // 主题颜色
      interact: '' // 互动类型
    }, // 模板上传数据
    onepage_upload: {
      title: '未命名单页',
      interact: '', // 互动
      format: '', // 板式
      color: '' // 颜色
    }, // 单页上传数据
    save_loading: false,
    init_loading: false,
    role: 'works', // works是作品  template是模板
    domain: '',
    path: '/index',
    page_set_activeName: 'page_config',
    save_pattern: '',
    onepage_index: 0,
    show_share_dialog: false, // 分享弹框
    show_preview_dialog: false, // 预览弹框
    show_previewSetting_dialog: false, // 预览与设置弹框
    preview_dialog_from_toolbox: false,
    show_template_upload_dialog: false, // 模板上传弹框
    show_one_page_dialog: false, // 上传提交弹框
    auto_save_timer: null,
    save_function: null, // 保存的回调函数
    info_function: null, // 保存主题信息的回调函数
    rotate_position: {
      click_x: 0,
      click_y: 0,
      origin_x: 0,
      origin_y: 0
    },
    zoom_ratio: 100,
    terms_dialog_visible: false,
    terms_dialog_type: '',
    shortcutPanelVisible: false,
    imgFilterPanelVisible: false,
    layerVisible: false,
    clipPathVisible: false,
    imgFilterPreviewVisible: false,
    imgFilterPreviewFilter: {},
    dialogLanternAddVisible: false,
    dialogLanternSettingVisible: false,
    lanternCategoryId: null,
    dialCategoryId: null,
    goldenEggCategoryId: null,
    gridCategoryId: null,
    companyInfo: null, //  公司名称
    materialSaveDialogVisible: false,
    qrCodeBeautyVisible: false, //  二维码美化
    qrCodeBeautyDataUrl: null,
    qrCodeBeautyLogoUrl: null,
    qrcBeautyUrl: null,
    qrCodeBeautyLink: '',
    isGetQrcSetting: false, // 仅获取二维码设置信息
    materialCategoryList: [],
    materialDetail: null,
    materialSaveTriggerByButton: false,
    is_first_add_module: false, //  是否是第一次添加模块
    appTag: '', //  表示应用信息
    ticket: '',
    demonstrationTag: false, //  表示是否是演示账户
    interactive_general_dialog: false, //  组件互动通用添加弹窗，用来代替原来各自的弹窗
    interactive_general_dialog_setting: false, //  组件互动通用设置弹窗，用来代替原来各自的弹窗
    interactive_general_dialog_lottery: false, //  通用的编辑抽奖活动弹窗
    curInteractiveGeneralDialog: '', //  当前组件互动通用弹窗的类型
    lotteryActiveTab: 'activityHome', //  抽奖活动弹窗的tab
    copy_obj: [], // 通栏数据临时储存
    addBgImg: ''
  },
  mutations: {
    set_bg_img(state, val) {
      state.addBgImg = val
    },
    SET_copy_obj(state, val) {
      state.copy_obj = val
    },
    CHANGE_SHOW_NAVBAR: (state, showNavbar) => {
      state.showNavbar = showNavbar
    },
    SET_module_Data(state, val) {
      if (state.module_Data && val && state.module_Data.tid === val.tid) {
        //  新值跟旧值一样的情况
        return
      }
      // 先滞空断开引用关系
      state.module_Data = null
      Vue.nextTick(() => {
        state.module_Data = val
      })
    },
    ADD_tid(state, val) {
      state.tid++
    },
    set_module_animation_index(state, val) {
      state.module_animation_index = val
    },
    set_select_animation_visible(state, val) {
      state.select_animation_visible = val
    },
    set_crop_img_dialog_visible(state, val) {
      state.crop_img_dialog_visible = val
    },
    set_crop_img_dialog_type(state, val) {
      state.crop_img_dialog_type = val
    },
    set_page_template_panel_visible(state, val) {
      state.page_template_panel_visible = val
    },
    set_edit_page_index(state, val) {
      state.edit_page_index = val
    },
    set_is_replace_img(state, val) {
      state.is_replace_img = val
    },
    set_is_replace_vo(state, val) {
      state.is_replace_vo = val
    },
    set_replace_img_type(state, val) {
      state.replace_img_type = val
    },
    ADD_select_module(state, module) {
      // 检查是否已经存在了
      const str = JSON.stringify(state.select_module)
      const tid = module.tid.toString()
      if (str.indexOf(tid) === -1) {
        state.select_module.push(module)
      }
    },
    DEL_select_module(state, id) {
      const select_module = state.select_module
      for (let i = 0; i < select_module.length; i++) {
        if (select_module[i].tid === id) {
          select_module.splice(i, 1)
        }
      }
    },
    CLEAR_select_module(state) {
      state.select_module = []
    },
    SET_selection_move(state, val) {
      state.multiple_selection_move = val
    },
    CLEAR_move_position(state) {
      state.move_position = {
        id: '',
        top: 0,
        left: 0
      }
    },
    SET_theme_id(state, val) {
      state.theme_id = val
    },
    SET_save_loading(state, val) {
      state.save_loading = val
    },
    SET_init_loading(state, val) {
      state.init_loading = val
    },
    SET_role(state, val) {
      state.role = val
    },
    SET_domain(state, val) {
      state.domain = val
    },
    SET_page_set_activeName(state, val) {
      state.page_set_activeName = val
    },
    SET_share_dialog(state, val) {
      state.show_share_dialog = val
    },
    SET_previewSetting_dialog(state, val) {
      state.show_previewSetting_dialog = val
    },
    SET_preview_dialog(state, val) {
      state.show_preview_dialog = val
    },
    SET_preview_dialog_from_toolbox(state, val) {
      state.preview_dialog_from_toolbox = val
    },
    SET_template_upload_dialog(state, val) {
      state.show_template_upload_dialog = val
    },
    SET_one_page_dialog(state, val) {
      state.show_one_page_dialog = val
    },
    SET_save_pattern(state, val) {
      state.save_pattern = val
    },
    SET_onepage_index(state, val) {
      state.onepage_index = val
    },
    SET_save_function(state, val) {
      state.save_function = val
    },
    SET_info_function(state, val) {
      state.info_function = val
    },
    SET_zoom_ratio(state, val) {
      state.zoom_ratio = val
    },
    SET_terms_dialog_visible(state, val) {
      state.terms_dialog_visible = val
    },
    SET_terms_dialog_type(state, val) {
      state.terms_dialog_type = val
    },
    setShortcutPanelVisible(state, val) {
      state.shortcutPanelVisible = val
    },
    setImgFilterPanelVisible(state, val) {
      state.imgFilterPanelVisible = val
    },
    setLayerlVisible(state, val) {
      state.layerVisible = val
    },
    setClipPathVisible(state, val) {
      state.clipPathVisible = val
    },
    setImgFilterPreviewVisible(state, val) {
      state.imgFilterPreviewVisible = val
    },
    setImgFilterPreviewFilter(state, val) {
      state.imgFilterPreviewFilter = val
    },
    setDialogLanternAddVisible(state, val) {
      state.dialogLanternAddVisible = val
    },
    setDialogLanternSettingVisible(state, val) {
      state.dialogLanternSettingVisible = val
    },
    setLanternCategoryId(state, val) {
      state.lanternCategoryId = val
    },
    setDialCategoryId(state, val) {
      state.dialCategoryId = val
    },
    setGoldenEggCategoryId(state, val) {
      state.goldenEggCategoryId = val
    },
    setGridCategoryId(state, val) {
      state.gridCategoryId = val
    },
    setMaterialSaveDialogVisible(state, val) {
      state.materialSaveDialogVisible = val
    },
    setMaterialSaveTriggerByButton(state, val) {
      state.materialSaveTriggerByButton = val
    },
    setMaterialCategoryList(state, val) {
      state.materialCategoryList = val
    },
    setMaterialDetail(state, val) {
      state.materialDetail = val
    },
    setIsFirstAddModule(state, val) {
      state.is_first_add_module = val
    },
    setAppTag(state, val) {
      state.appTag = val
    },
    setTicket(state, val) {
      state.ticket = val
    },
    setDemonstrationTag(state, val) {
      state.demonstrationTag = val
    },
    setInteractiveGeneralDialog(state, val) {
      state.interactive_general_dialog = val
    },
    setInteractiveGeneralDialogSetting(state, val) {
      state.interactive_general_dialog_setting = val
    },
    setInteractiveGeneralDialogLottery(state, val) {
      state.interactive_general_dialog_lottery = val
    },
    setCurInteractiveGeneralDialog(state, val) {
      state.curInteractiveGeneralDialog = val
    },
    setLotteryActiveTab(state, val) {
      state.lotteryActiveTab = val
    }
  },
  actions: {},
  getters: {
    create_link(state) {
      console.log(285, 'state:', state)
      return (
        state.domain + state.path + '?id=' + state.theme_id + '&role=' + state.role + '&pattern=' + state.save_pattern
      )
    }
  }
}
export default app
